/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IManageContentScope extends angular.IScope {
        model: models.ContentManagementModel;
    }

    export class ManageContentController implements IController {
        scope: IManageContentScope;

        constructor($scope: IManageContentScope) {
            this.scope = $scope;
            this.scope.model = new models.ContentManagementModel();
        }
    }
}

warsApp.registerController('ManageContentController', ['$scope']);